/**
 * @author kper6454
 * */
import {
  RECEIVE_MODULE_GROUP_DELETE,
  RECEIVE_ALL_COMMODITIES,
  RECEIVE_ALL_MODULES,
  RECEIVE_ITEM_PRICE,
  RECEIVE_MODULE_GROUP_UPDATE,
  RECEIVE_MODULE_GROUPS_ASSOCIATIONS,
  RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  RECEIVE_ALL_LOADING_AREAS,
  RECEIVE_COMMODITY_DETAILS,
  RECEIVE_COMMODITY_GROUP_UPDATE,
  RECEIVE_ALL_PRICE_MODULE_ITEMS,
  RECEIVE_LOADING_AREA_DETAILS,
  RECEIVE_LOADING_AREA_CREATE,
  RECEIVE_LOADING_AREA_UPDATE,
} from '../actions/costMaintenanceActions';
import initialState from './initialState';

export default function priceModuleDataReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.priceModule.data;
  }

  if (type === RECEIVE_ALL_MODULES) {
    return { ...state, modules: data };
  }

  if (type === RECEIVE_ITEM_PRICE) {
    return { ...state, itemPrice: data };
  }

  if (type === RECEIVE_ALL_COMMODITIES) {
    return {
      ...state,
      rawCommodities: data,
    };
  }

  if (type === RECEIVE_MODULE_GROUPS_ASSOCIATIONS) {
    return { ...state, moduleView: data };
  }

  if (type === RECEIVE_MODULE_GROUP_DELETE) {
    return {
      ...state,
      moduleView: state.moduleView.filter(
        (module) => module.module_id !== data,
      ),
    };
  }

  if (type === RECEIVE_MODULE_GROUP_UPDATE) {
    const result = {
      ...state,
      moduleView: state.moduleView.map((module) => {
        if (module.module_id === data.module_id) {
          return {
            ...module,
            ...data,
          };
        }

        return module;
      }),
    };

    return result;
  }

  if (
    type === RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT
    || type === RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT
  ) {
    return {
      ...state,
      moduleView: state.moduleView.map((module) => {
        if (module.module_id === data.module.module_id) {
          return data.module;
        }

        return module;
      }),
    };
  }

  if (type === RECEIVE_ALL_LOADING_AREAS) {
    return { ...state, loadingAreas: data };
  }

  if (type === RECEIVE_COMMODITY_DETAILS) {
    return {
      ...state,
      commodityDetails: data,
    };
  }

  if (type === RECEIVE_ALL_PRICE_MODULE_ITEMS) {
    return {
      ...state,
      items: data,
    };
  }

  if (type === RECEIVE_COMMODITY_GROUP_UPDATE) {
    return {
      ...state,
      commodityDetails: {
        ...data,
        items: state.commodityDetails.items,
      },
      rawCommodities: state.rawCommodities.map((commodity) => {
        if (commodity.comcode_id === data.comcode_id) {
          return data;
        }
        return commodity;
      }),
    };
  }

  if (type === RECEIVE_LOADING_AREA_DETAILS) {
    return {
      ...state,
      loadingAreaDetails: data,
    };
  }

  if (type === RECEIVE_LOADING_AREA_CREATE) {
    return {
      ...state,
      loadingAreas: [...state.loadingAreas, data],
    };
  }

  if (type === RECEIVE_LOADING_AREA_UPDATE) {
    return {
      ...state,
      loadingAreas: state.loadingAreas.map((loadingArea) => {
        if (loadingArea.loading_area_id === data.loading_area_id) {
          return data;
        }
        return loadingArea;
      }),
    };
  }

  return state;
}
